import pageViewStyle from 'src/components/View/Page/pageView.style';

const chatViewStyle = (theme) => ({
  root: {
    ...pageViewStyle(theme)?.root,
    // Sized against the viewport rather than the parent, so it cannot see
    // the top-message bar the way a percentage height would. Subtracting
    // the measured bar height keeps this screen exactly filling the
    // scroller instead of overrunning it by the bar's height -- that
    // overrun was the scroll that let the pinned banner cover the chat
    // toolbar's kebab. 0px when no banner is showing.
    height: 'calc(100vh - 88px - var(--cp-top-banner-height, 0px))',
    padding: theme.spacing(0),
  },
});

export default chatViewStyle;
